import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { gql } from '@apollo/client';

export const GET_HARDWARE_DATA = gql`
  query getHardware($id: ID) {
    hardware(id: $id) {
      data {
        id
        attributes {
          external_id
          name
          disabled
          category
          query
          enmon_details
          reseller {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export type HardwaresDataItem = SerializedHardware & {
  reseller: Pick<SerializedHardware['reseller'], 'id' | 'name'>;
  id: SerializedHardware['id'];
  name: SerializedHardware['name'];
  externalId: SerializedHardware['external_id'];
  category: SerializedHardware['category'];
  disabled: SerializedHardware['disabled'];
  query: SerializedHardware['query'];
  enmon_details: SerializedHardware['enmon_details'];
};

export interface HardwareData {
  hardware: {
    data: HardwaresDataItem;
  };
}
